import { createBrowserHistory, type History } from 'history';

export const history: History = createBrowserHistory({ window }) as unknown as History;

// allow reassignment in tests
export function setHistory(_newHistory: History) {
  // nothing to do
}
